export const buildCoachProfileReviewPath = ({
  coachId,
  transactionId,
  reviewSource = 'inbox',
}) => {
  const params = new URLSearchParams({
    reviewTransactionId: String(transactionId),
    reviewSource: String(reviewSource),
  });
  return `/u/${encodeURIComponent(String(coachId))}?${params.toString()}#reviews`;
};

export const PENDING_REVIEW_OPPORTUNITIES_LIMIT = 10;

const SESSION_DISMISS_PREFIX = 'pending-coach-review-dismissed';
const PROFILE_DISMISS_PREFIX = 'coach-profile-review-dismissed';

export const getLoginPopupDismissKey = transactionId =>
  `${SESSION_DISMISS_PREFIX}:${transactionId}`;

export const getCoachProfilePopupDismissKey = (coachId, transactionId) =>
  `${PROFILE_DISMISS_PREFIX}:${coachId}:${transactionId}`;

export const isSessionDismissed = key => {
  if (typeof window === 'undefined' || !key) return false;
  try {
    return window.sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

export const dismissForSession = key => {
  if (typeof window === 'undefined' || !key) return;
  try {
    window.sessionStorage.setItem(key, '1');
  } catch {
    // ignore quota / private mode
  }
};

export const filterLoginPopupOpportunities = opportunities =>
  (Array.isArray(opportunities) ? opportunities : []).filter(
    o => o?.transactionId && !isSessionDismissed(getLoginPopupDismissKey(o.transactionId))
  );

export const filterCoachProfilePopupOpportunities = (opportunities, coachId) =>
  (Array.isArray(opportunities) ? opportunities : []).filter(o => {
    if (!o?.transactionId) return false;
    if (coachId && String(o.coachId) !== String(coachId)) return false;
    return !isSessionDismissed(getCoachProfilePopupDismissKey(coachId, o.transactionId));
  });

/** Clear login-popup dismissals (e.g. after logout so the next login can prompt again). */
export const clearLoginReviewPopupDismissals = () => {
  if (typeof window === 'undefined') return;
  try {
    const keysToRemove = [];
    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      const key = window.sessionStorage.key(i);
      if (key && key.startsWith(`${SESSION_DISMISS_PREFIX}:`)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => window.sessionStorage.removeItem(key));
  } catch {
    // ignore
  }
};
